module.exports = __webpack_public_path__ + "31f3c941d08b6b17f89f873a5d22e2e8.glb";